import React from 'react';
import '../App.css';
import logo from '../assets/azf-logo.png'; // Change this to the actual logo image path in your project

const Header = () => (
  <header className="header">
    {/* Logo + Foundation Name */}
    <div className="header-left">
      <img src={logo} alt="Abdullah Zaman Foundation" className="header-logo" />
      <span className="logo-title">Abdullah Zaman Foundation</span>
    </div>
    {/* Nav Links */}
    <nav className="header-nav">
      <a href="#about" className="nav-link">About</a>
      <a href="#impacts" className="nav-link">Impact</a>
      <a href="#process" className="nav-link">How It Works</a>
      <a href="#contact" className="nav-link">Contact</a>

      <a href="https://docs.google.com/forms/d/1eRGV-rcK4nzIKdE4zWMovypxxJat4Xhl5zP2A2vqtpQ/viewform?ts=6812c89d&edit_requested=true" className="btnPrimary">Apply for a Grant</a>
      <a href="#contact" className="btnSecondary">Donate Now</a>
    </nav>
  </header>
);

export default Header;
